module.exports = __webpack_public_path__ + "static/media/logo17.eaa5f73e.png";